<template>
    <div class="movie-box page-padding-bottom2 ticket-orders-detail-wrapper">
        <!-- 返回 -->
        <div class="movie-box">
            <MovieGoBack :style="backstyle" :arrowStyle="arrowStyle" :text="'订单详情'" :titleStyle="titleStyle"></MovieGoBack>
        </div>

        <div class="ticket-order-info-wrapper padding20 page-background-color-white">
            <div class="page-div-bottom-line" v-if="ticket_detail.refund_status == 0 || ticket_detail.refund_status == 3">
                <p class="page-margin-bottom1 acea-row row-between-wrapper" v-if="ticket_detail.order_number">
                    <span>订单号：{{ticket_detail.order_number}}</span>
                    <span class="font-color-red">{{ticket_detail.order_status}}</span>
                </p>
                <p class="page-margin-bottom1" v-if="ticket_detail.order_time">
                    下单时间：{{ticket_detail.order_time}}
                </p>
            </div>
            <div class="page-div-bottom-line" v-if="ticket_detail.refund_status == 2 || ticket_detail.refund_status == 1">
                <p class="page-margin-bottom1 acea-row row-between-wrapper" v-if="ticket_detail.refund_id">
                    <span v-if="ticket_detail.refund_id">退款流水号：{{ticket_detail.refund_id}}</span>
                    <span class="font-color-red">{{ticket_detail.order_status}}</span>
                </p>
                <p class="page-margin-bottom1 acea-row row-between-wrapper" v-if="!ticket_detail.refund_id">
                    <span v-if="ticket_detail.order_number">订单号：{{ticket_detail.order_number}}</span>
                    <span class="font-color-red">{{ticket_detail.order_status}}</span>
                </p>
                <p class="page-margin-bottom1" v-if="ticket_detail.refund_time">
                    退款时间：{{ticket_detail.refund_time}}
                </p>
            </div>
            <div class="movie-box page-margin-top2">
                <p class="page-margin-bottom1" v-if="ticket_detail.title">票品名：{{`＜${ticket_detail.title}＞`}}</p>
                <p class="page-margin-bottom1" v-if="ticket_detail.time">出游日期：{{ticket_detail.time}}</p>
                <p class="page-margin-bottom1" v-if="ticket_detail.number">数量：{{ticket_detail.number}}张</p>
                <p class="font-color-red page-margin-bottom1" v-if="ticket_detail.price">总价：{{ticket_detail.price}}</p>
                <p class="page-margin-bottom1" v-if="ticket_detail.order_payType">支付方式：{{ticket_detail.order_payType}}</p>
                <p class="page-margin-bottom1 acea-row row-middle row-between" v-if="ticket_detail._refund_ticket">
                    <span>是否可退：{{ticket_detail._refund_ticket == 1 ? "可退":"不可退"}}</span>
                    <span class="refund-btn" @click="goRefund" v-if="(ticket_detail._refund_ticket == 1) && (ticket_detail.refund_status == 0)">退票</span>
                </p>
                <p class="font-color-red" v-if="ticket_detail.plan_refundprice && ticket_detail.refund_status == 1"><!-- 申请退款中  -->
                    预计退款金额：{{ticket_detail.plan_refundprice}}
                </p>
                <p class="font-color-red" v-if="ticket_detail.refund_price && ticket_detail.refund_status == 2"><!-- 已退款  -->
                    退款金额：{{ticket_detail.refund_price}}
                </p>
                <!-- 退订失败  -->
                <p class="page-margin-bottom1" v-if="ticket_detail.refund_failreason && ticket_detail.refund_status == 3">
                    退订失败原因: {{ticket_detail.refund_failreason}}
                </p>
                <p class="page-margin-bottom1" v-if="ticket_detail.refund_failremark && ticket_detail.refund_status == 3">
                    退订失败备注: {{ticket_detail.refund_failremark}}
                </p>
            </div>
        </div>

        <div class="ticket-order-info-wrapper padding20 page-background-color-white module-border" v-if="(ticket_detail.orderItemInfos && ticket_detail.orderItemInfos.length !=0) && (ticket_detail.refund_status == 0 || ticket_detail.refund_status == 3)">
            <div class="page-margin-bottom2" v-for="(item, ind) in ticket_detail.orderItemInfos" :key="ind">
                <div class="page-margin-bottom2" v-if="item.xieChengOrderId">
                    <span class="admission-code">订单号：</span><span class="order-number">{{item.xieChengOrderId}}</span>
                </div>
                <div class="page-margin-bottom2" v-if="item.AdmissionCertificate">
                    <span class="admission-code">入园码：</span>{{item.AdmissionCertificate}}
                </div>
                <!-- <div class="page-margin-bottom2 page-text-center" v-if="item.QR_code">
                    <span class="admission-code">二维辅助码：</span>{{item.QR_code}}
                </div> -->
                <div>
                    <p class="admission-code page-margin-bottom1" v-if="ticket_detail.isQR_code">二维码：</p>
                    <div class="page-text-center EWM" v-if="!item.QR_url && ticket_detail.isQR_code">
                        待出票...
                    </div>
                    <div class="page-text-center EWM" v-if="item.QR_url">
                        <img :src="item.QR_url" />
                    </div>
                </div>
            </div>
        </div>

        <div class="ticket-order-info-wrapper page-background-color-white" v-if="ticket_detail.refund_status == 0 || ticket_detail.refund_status == 3">
            <div class="title-bg padding20 title-font">
                门票说明
            </div>
            <ul class="movie-box pad20">
                <li class="page-div-bottom-line padtb20" v-for="(item, key) in noticeList.slice(0,2)" :key="key">
                    <p class="page-margin-bottom1 font-color-red">{{item.title}}</p>
                    <p v-for="(val, ind) in item.content" :key="ind">{{val.content}}</p>
                </li>
                <li class="padtb20 page-text-center" @click="showInstructions(true)">
                    更多说明 >
                </li>
            </ul>
        </div>

        <!--  -->
        <div class="ticket-order-info-wrapper page-background-color-white" v-if="ticket_detail.refund_status == 0 || ticket_detail.refund_status == 3">
            <div class="title-bg padding20 title-font" @click="gotoTicketDetail">
                景点信息
            </div>
            <ul class="movie-box pad20">
                <li class="page-div-bottom-line padtb20" v-for="(item, key) in scenicSpot.slice(0,2)" :key="key">
                    <p class="page-margin-bottom1 font-color-red">{{item.title}}</p>
                    <p v-for="(val, ind) in item.content" :key="ind" v-html="val.content"></p>
                </li>
                <li class="padtb20 page-text-center" @click="showScenicSpot(true)">
                    更多说明 >
                </li>
            </ul>
        </div>


        <!-- 取票人信息 -->
        <div class="ticket-order-info-wrapper page-background-color-white" v-if="ticket_detail.refund_status == 0 || ticket_detail.refund_status == 3">
            <div class="title-bg padding20 title-font">
                取票人信息
            </div>
            <ul class="movie-box padding20">
                <li v-if="Object.keys(ticket_collector).length > 0">
                    <p class="page-margin-bottom1" v-if="ticket_collector.name">姓名：{{ticket_collector.name}}</p>
                    <p class="page-margin-bottom1" v-if="ticket_collector.phone">手机号：{{ticket_collector.phone}}</p>
                    <p class="page-margin-bottom1" v-if="ticket_collector.email">邮箱：{{ticket_collector.email}}</p>
                </li>
                <li class="page-text-center" v-else>无</li>
            </ul>
        </div>

        <!-- 游客信息 -->
        <div class="ticket-order-info-wrapper page-background-color-white" v-if="ticket_detail.refund_status == 0 || ticket_detail.refund_status == 3">
            <div class="title-bg padding20 title-font">
                游客信息
            </div>
            <ul class="movie-box pad20" v-if="ticket_tourist_list.length > 0">
                <li class="page-div-bottom-line padtb20" v-for="(item, key) in ticket_tourist_list" :key="key">
                    <p class="page-margin-bottom1 acea-row row-between" v-if="item.name">
                        <span>姓名：{{item.name}}</span>
                        <!-- <span class="font-color-red">已退票</span> (部分退=>标记已退款游客)-->
                    </p>
                    <p class="page-margin-bottom1" v-if="item._gender">性别：{{item._gender}}</p>
                    <p class="page-margin-bottom1" v-if="item.nationality">国籍：{{item.nationality}}</p>
                    <p class="page-margin-bottom1" v-if="item.phone">手机号：{{item.phone}}</p>
                    <p class="page-margin-bottom1" v-if="item._idcardname">证件类型：{{item._idcardname}}</p>
                    <p class="page-margin-bottom1" v-if="item.id">证件号：{{item.id}}</p>
                </li>
                <div class="padtb20 page-text-center" v-if="!is_ticket_tourist && ticket_tourist.length > 1" @click="ticket_tourist_fn(true)">点击展开 ﹀</div>
                <div class="padtb20 page-text-center" v-if="is_ticket_tourist  && ticket_tourist.length > 1" @click="ticket_tourist_fn(false)">点击合上 ﹀</div>
            </ul>
            <ul class="movie-box pad20 page-text-center" v-else>无</ul>
        </div>

        <!-- 附加信息  -->
        <div class="ticket-order-info-wrapper page-background-color-white" v-if="additional_list_slice.length > 0">
            <div class="title-bg padding20 title-font">附加信息</div>
            <ul class="movie-box pad20">
                <li class="page-div-bottom-line padtb20">
                    <p class="page-margin-bottom1" v-for="(item, index) in additional_list_slice" :key="index">
                        <span>{{item.title}}：</span><span class="margin-right" v-for="(val, num) in item.value" :key="num">{{val}}</span>
                    </p>
                </li>
                <div class="padtb20 page-text-center" v-if="!is_additional && additional_list_slice.length > 1" @click="additional_fn(true)">点击展开 ﹀</div>
                <div class="padtb20 page-text-center" v-if="is_additional  && additional_list_slice.length > 1" @click="additional_fn(false)">点击合上 ﹀</div>
            </ul>
        </div>

        <!-- 退票信息 (部分退)-->
        <!-- <div class="ticket-order-info-wrapper page-background-color-white">
            <div class="title-refund padding20 title-font">
                退票信息
            </div>
            <ul class="movie-box pad20">
                <li class="page-div-bottom-line padtb20">
                    <p class="page-margin-bottom1">退票时间：2021-07-21 09：30:21</p>
                    <p class="page-margin-bottom1">退票数量：1</p>
                    <p class="page-margin-bottom1">退票金额：22</p>
                </li>
            </ul>
        </div> -->

        <!-- 预订须知 -->
        <TicketNotice :title="'使用须知'" :notice="notice" :noticeList="noticeList" @noticeClose="showInstructions"></TicketNotice>
        <!-- 景点信息 -->
        <TicketNotice :title="'景点信息'" :notice="showscenicSpot" :noticeList="scenicSpot" @noticeClose="showScenicSpot"></TicketNotice>
    </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import TicketNotice from "@components/TicketNotice.vue";
import { getOrderDetailDate } from "@api/ticket.js";

export default {
    name: "TicketOrdersDetail",
    components: {
        MovieGoBack,
        TicketNotice
    },
    data: function () {
        return {
            backstyle: {
                background: '#fff'
            },
            arrowStyle: {
                color: '#666'
            },
            titleStyle: {
                color: '#666',
                'text-align': 'center',
                "font-size": '.29rem'
            },
            noticeList: [//门票说明
                // {
                //     title: "有效期",
                //     content: [{content: "2021-12-24"}]
                // }
            ],
            scenicSpot: [], //景点信息
            notice: false, //预定须知
            showscenicSpot: false, //景点须知
            id: this.$route.params.id,
            ticket_detail: {
                // title: "北京故宫博物馆成人票+珍宝馆+钟表馆+手机电子语音讲解",
                // time: "2021-05-03",//出游时间
                // number: 2,
                // price: 220,
                // order_number: "订单号",
                // order_time: "下单时间",
                // order_status: "订单状态",
                // order_payType: "支付方式",
                // QR_url: "二维码图片",
                // QR_code: "二维码",
                // AdmissionCertificate: "入园凭证",
                // refund_price: "退款金额"
                // isQR_code: "是否凭借二维码入园"
                ticket_id: ""//此门票景点id
            },
            ticket_collector: {//取票
                // name: "zz",
                // phone: 12336522563,
                // email: ""
            },
            ticket_tourist_list: [],
            additional_list: [], //附加信息-全部
            additional_list_slice: [], //附加信息-部分
            is_additional: false, //是否展开附加信息
            is_ticket_tourist: false,
            ticket_tourist: [ // 游客信息
                // {
                //     index: 1,
                //     name: cname || ename,  cname//中文姓名  ename//英文姓名
                //     phone: "14525633256",
                //     id: "145623199406127856",
                //
                    //    mobile	//游客手机号
                    //    _idcardname	//证件类型
                    //    idcardno	//证件号
                    //    nationality	//国籍
                    //    _gender	//性别
                    //    birthdate	//出生日期
                    //    birthcity	//出生地（省份）
                    //    cardvaliduntil	//证件有效期
                    //    visaorgan	//发证机关
                    //    passportdate	//发证日期
                    //    visacountry	//发签证国家
                    //    passportno	//护照号码
                    //    issuedate	//签发日期
                    //    idcardtimelimit	//护照有效期
                    //    passporttype	//护照类型
                    //    mobileintlcode	//海外手机国外区号
                    //    weight	//体重（kg）
                    //    height	//身高（cm）
                    //    shoesize	//鞋码（欧码）
                    //    myopia	//近视度数（度）
                // }
            ],
        }
    },
    mounted: function () {
        this.getDate();
    },
    methods: {
        additional_fn: function (val) {
            this.is_additional = val;
            if (val) {
                this.additional_list_slice = this.additional_list;
            } else {
                this.additional_list_slice = this.additional_list.slice(0, 2);
            }
        },
        gotoTicketDetail: function () {
            if (!this.ticket_detail.ticket_id) return;
            this.$router.push("/ticketDetail/"+this.ticket_detail.ticket_id);
        },
        goRefund: function () {
            this.$router.replace("/ticketRefund/"+ this.ticket_detail.id);
        },
        ticket_tourist_fn: function (boo) {
            this.is_ticket_tourist = boo;
            if (boo) {
                this.ticket_tourist_list = this.ticket_tourist;
            } else {
                this.ticket_tourist_list = this.ticket_tourist.slice(0, 1);
            }
        },
        encryption_number: function (number) {
            if (!number) return;
            let _number = number;
            let snippet = _number.slice(3, _number.length - 4);
            let mi = Array.from(snippet, function () { return '*'}).join("");
            let arr_number = _number.split("");
            arr_number.splice(3, snippet.length, mi);
            return arr_number.join("");
        },
        getDate: function () {
            let id = this.id || this.$route.params.id;
            this.$dialog.loading.open("正在加载");
            getOrderDetailDate(id).then((res)=>{
                this.$dialog.loading.close();
                // console.log(res,"res");
                if (res.status !== 200) {
                    this.$dialog.toast({ mes: res.msg });
                    return;
                }
                let orderInfo = res && res.data && res.data.orderInfo;//订单信息
                let ticketOrderInfo = res && res.data && res.data.ticketOrderInfo && res.data.ticketOrderInfo.OrderItemInfos; //
                let orderItemInfos = [];
                ticketOrderInfo && ticketOrderInfo.forEach((resl)=>{
                    orderItemInfos.push({
                        xieChengOrderId: res && res.data && res.data.ticketOrderInfo && res.data.ticketOrderInfo.OrderID || "", //携程订单号
                        QR_url: resl.ImageUrl || "",//二维码图片
                        QR_code: resl.VoucherCode || "",//二维码辅助码
                        AdmissionCertificate: resl.AdmissionCertificate || ""//入园凭证
                    });
                });
                this.ticket_detail = {
                    id: orderInfo.id,
                    title: orderInfo.tickets_name || "",
                    time: orderInfo._use_time || "",
                    number: orderInfo.total_num || "",
                    price: orderInfo.pay_price || "",
                    order_number: orderInfo.order_id || "",
                    order_time: orderInfo.create_time || "",
                    order_status: orderInfo._status._title || "",
                    refund_status: orderInfo.refund_status || "", //退款状态 0未退/ 1申请中/ 2已退款 / 3退款失败
                    _refund_ticket: orderInfo._refund_ticket || "",//是否支持可退
                    order_payType: orderInfo._status._payType || "", //支付方式
                    orderItemInfos: orderItemInfos,//产品资源信息 - 数组
                    refund_price: orderInfo.refund_price || "", //实际退款金额
                    plan_refundprice: orderInfo.plan_refund_price || "", // 预计退款金额
                    refund_id: orderInfo.refund_id || "", //流水号
                    refund_time: orderInfo._refund_time || "" ,//退款时间
                    refund_failreason: orderInfo.refund_failreason || "", //退订失败原因
                    refund_failremark: orderInfo.refund_failremark || "", //退订失败备注
                    ticket_id: orderInfo.crtip_info_id // 此门票景点id
                };
                this.ticket_collector = { //取票人
                    name: orderInfo.contact_name || "",
                    phone: this.encryption_number(orderInfo.contact_mobile) || "",
                    email: orderInfo.contact_email || ""
                };
                let passenerInfo = res && res.data && res.data.passenerInfo;//游客信息
                let _tourist = [];
                passenerInfo && passenerInfo.forEach((item,ind)=>{
                     _tourist.push({
                        index: ind + 1,
                        name: item.cname || item.ename || "",//姓名
                        phone: this.encryption_number(item.mobile) || "",//手机号
                        _phone: item.mobile,
                        id: this.encryption_number(item.idcardno) ||"",//证件号
                        _id: item.idcardno,
                        _idcardname: item._idcardname || "",//证件类型
                        _gender: item._gender || "",//性别
                        nationality: item.nationality || "" //国籍
                     });
                });
                this.ticket_tourist = _tourist;
                this.ticket_tourist_list = _tourist.slice(0, 1);

                //附加信息
                let additional = res && res.data && res.data.addInfos || [];
                let _additional = [];
                additional && additional.forEach((element)=>{
                    const list = element.itemname.split('；');
                    _additional.push({
                        title: element.name,
                        value: list
                    });
                });
                this.additional_list = _additional;
                this.additional_list_slice = _additional.slice(0, 2);

                // 使用须知
                let _noticeList = [];
                let resourceInfo = res && res.data && res.data.resourceInfo;
                resourceInfo && resourceInfo.forEach((value)=>{
                    let contents = [];
                    value.ResourceAddInfoDetailList && value.ResourceAddInfoDetailList.forEach((info)=>{
                        let desc = info.DescDetail || "";
                        if (value.TitleCode == "113" && value.SubTitleCode == "13" && desc) {
                            this.ticket_detail.isQR_code = (desc.indexOf("二维码") !== -1);
                        }
                        contents.push({
                            content: desc
                        });
                    });
                    _noticeList.push({
                        title: value.SubTitle,
                        content: contents
                    }); 
                });
                this.noticeList = _noticeList;

                // 景点信息
                let _scenicSpot = [];
                let crtipInfo = res && res.data && res.data.crtipInfo;
                crtipInfo && crtipInfo.forEach((value)=>{
                    let contents = [];
                    value.ProductAddInfoDetailList && value.ProductAddInfoDetailList.forEach((info)=>{
                        let desc = info.DescDetail || "";
                        if( orderInfo.crtip_id == 2045497 && value.AddInfoSubTitleCode == '98') {
                            desc = "开放时间：全年 周一-周五10:00-19:00 周六日09:00-20:00（说明：景区开放时间动态变化，实际请以出行当天景区官方小程序公示的营业时间为准）";
                        }

                        contents.push({
                            content: desc
                        });
                    });
                    _scenicSpot.push({
                        title: value.AddInfoSubTitleName,
                        content: contents
                    });
                });
                this.scenicSpot = _scenicSpot;

            }).catch((err)=>{
                console.log(err);
                this.$dialog.loading.close();
                this.$dialog.toast({ mes: err.msg });
            });
        },
        showInstructions: function (val) {
            this.notice = val;
        },
        showScenicSpot: function (val) {
            this.showscenicSpot = val;
        }
    }
}
</script>

<style scoped>
.title-bg {
    background-color: #e9332312;
}
.title-refund {
    background-color: #2291f81c;
}
.ticket-order-info-wrapper {
    width: 92%;
    margin: .2rem auto 0;
    border-radius: .1rem;
}
.title-font {
    font-size: .32rem;
    color: #666;
}
.page-div-bottom-line:last-child {
    border-bottom: none;
}
.admission-code {
    font-size: .32rem;
    color: #666;
    margin-right: .1rem;
}
.EWM {
    background: #f5f5f5;
    padding: .2rem 0;
    margin: 0 0.6rem;
}
.EWM img {
    width: 4rem;
    height: 4rem;
}
.refund-btn {
    padding: .04rem .4rem;
    text-align: center;
    border-radius: .3rem;
    border: .02rem solid #666;
}
.order-number {
    background: #f5f5f5;
    padding: .15rem .2rem;
}
.module-border {
    border-bottom: .3rem dotted rgb(245, 245, 245);
    border-top: .3rem dotted rgb(245, 245, 245);
}
.margin-right {
    margin-right: .1rem;
}
</style>